<template>
  <div>
    <div class="search">
      <div class="search-field">
        <input
          autocomplete="off"
          type="text"
          @focus="focusIn"
          @blur="focusOut"
          class="search-input"
          v-model="searchQuery"
          data-cy="tbSearchInput"
          placeholder="Search for items, users, and groups"
          @keyup.enter="search"
          ref="searchInput"
        />
      </div>
      <div class="search-button">
        <md-button
          class="md-icon-button"
          @click="search"
          data-cy="tbSearchSubmit"
          :md-ripple="false"
        >
          <md-icon>search</md-icon>
        </md-button>
      </div>
    </div>
    <div class="autocomplete-positioning" :class="[getLoggedPosition, getWidePosition]">
      <SearchAutocompleteResults
        :query="searchQuery"
        :isInputFocused="searchFocused"
      />
    </div>
  </div>
</template>
<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import SearchAutocompleteResults from "../../components/molecules/SearchAutocompleteResults.vue";

export default {
  name: "SSearchTopBar",
  mixins: [UserHelperVue],
  components: {
    SearchAutocompleteResults,
  },
  data() {
    return {
      searchQuery: "",
      searchFocused: false,
      displayNone: window.outerWidth < 1112,
    };
  },
  computed: {
    getLoggedPosition() {
      if (this.loggedUser.id) return "loggedPosition";
      return ""; //
    },
    getWidePosition() {
      if (this.loggedUser.id) return "loggedWide";
      return "guestWide"; //
    },
  },
  watch: {
    $route() {
      this.clearQuery()

      // this.$nextTick(() => this.clearQuery());
    },
  },
  methods: {
    focusIn() {
      this.searchFocused = true
    },
    focusOut() {
      this.searchFocused = false
      this.displayNone = window.outerWidth < 1112;
    },
    search() {
      const query = encodeURI(this.searchQuery.trim());
      this.$refs.searchInput.blur();

      if (query) {
        if (this.loggedUser.id) {
          this.$router.push(`/s-app/search-result/${query}`);
        } else {
          this.$router.push(`/search-result-landing/${query}`);
        }
      }
    },
    clearQuery() {
      this.searchQuery = "";
    },
  },
  created() {
    // if (this.$route.name === "SSearchResultFromLandingPage") {
    //   console.log("query", this.$route)
    //   this.searchQuery = this.$route.params.query;
    // }
  },
};

</script>

<style scoped>
.search {
  width: 100%;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.search-field {
  width: 100%;
}

.search-button {
  width: auto;
}
.search-button i {
  color: rgba(0, 0, 0, 0.6);
}

.desktop-search .input-focus {
  width: 100%;
  box-shadow: 0 0 0 1pt grey;
  transition: 0.1s;
}

.mobile-search .input-focus {
  width: 100% ;
}

.mobile-search {
  margin: auto 0;
  min-height: unset !important;
}

.display-none {
  display: none;
}

.search-input {
  padding: 0 !important;
  border: none;
  background: #ffffff;
  width: 100%;
  height: 40px;
  letter-spacing: 1.25px;
  color: rgba(0, 0, 0, 0.6);
  margin-right: 10px;
  margin-left: 10px;
  text-indent: 0;
}

.search-input input, input:focus {
  outline: none;
}

.autocomplete-positioning {
  position: absolute;
  z-index: 10010;
  width: 40%;
  left: 45.4%;
  top: 38%;
}

@media screen and (min-width: 480px) {
}
@media screen and (min-width: 720px) {
}

@media screen and (max-width: 1024px) {
  .autocomplete-positioning {
    width: 100%;
    left: 0;
    top: 69%;
  }
}

@media screen and (min-width: 1112px) {
  .search {
    border-radius: 6px;
  }
  .guestWide {
    left: 30%;
  }
  .loggedPosition {
    left: 30%;
  }
}

@media screen and (min-width: 1400px) {
  .guestWide {
    left: 30%;
  }
  .loggedWide {
    left: 30%;
  }
}
</style>
